import { useState } from 'react';
import { setPlayerId } from '../storage.js';
import type { SeasonView } from '../data.js';

/** First run, and the recovery path after a mis-tap or a roster change (§5.3, §5.7). */
export default function NamePicker({ view }: { view: SeasonView }) {
  const [saving, setSaving] = useState(false);

  const players = [
    ...new Map(
      view.groups.flatMap((g) => g.config.players.map((p) => [p.id, p] as const)),
    ).values(),
  ].sort((a, b) => a.name.localeCompare(b.name));

  function choose(id: string) {
    setSaving(true);
    setPlayerId(id);
    // A reload is the simplest way to re-key every query with the new player header.
    window.location.reload();
  }

  return (
    <div className="screen center">
      <div className="card">
        <h1>Select your name</h1>
        <p className="muted">So the app knows whose schedule to show.</p>
        <ul className="picker">
          {players.map((player) => (
            <li key={player.id}>
              <button type="button" disabled={saving} onClick={() => choose(player.id)}>
                {player.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
